/**
 * Shared layout for all auth pages — centered card with branding.
 */

interface AuthLayoutProps {
  children:    React.ReactNode;
  title:       string;
  subtitle?:   string;
}

export default function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-surface-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">

        {/* WombCat Logo + Brand */}
        <div className="text-center mb-8">
          <img
            src="/wombcat-logo.png"
            alt="WombCat"
            className="mx-auto w-28 h-28 object-contain mb-3"
          />
          <h1 className="text-2xl font-bold text-surface-900">WombCat CMS</h1>
          <p className="text-sm text-surface-500 mt-1">Pregnancy Content Management</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-card border border-surface-200 p-8">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-surface-900">{title}</h2>
            {subtitle && (
              <p className="text-sm text-surface-500 mt-1">{subtitle}</p>
            )}
          </div>
          {children}
        </div>

        {/* Angels Army Ministry Logo */}
        <div className="flex flex-col items-center mt-8 gap-2">
          <img
            src="/angels-army-logo.png"
            alt="Angels Army Ministry"
            className="w-14 h-14 object-contain"
          />
          <p className="text-xs text-surface-400 font-medium">Angels Army Ministry</p>
          <p className="text-xs text-surface-400">
            © {new Date().getFullYear()} WombCat. All rights reserved.
          </p>
        </div>

      </div>
    </div>
  );
}
